import { render } from "./WithText.vue?vue&type=template&id=3f8387ae"
import script from "./WithText.vue?vue&type=script&lang=js"
export * from "./WithText.vue?vue&type=script&lang=js"
script.render = render

export default script